import { Component, ViewContainerRef, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { MatFormField, MatLabel, MatInput, MatSuffix, MatError } from '@angular/material/input';
import { NgClass } from '@angular/common';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';

@Component({
    selector: 'app-form-date',
    templateUrl: './form-date.component.html',
    styleUrls: ['form-date.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatFormField, NgClass, ReactiveFormsModule, MatLabel, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatError]
})
export class FormdateComponent implements Field, OnInit {
  public FormControlName;
  config: FieldConfig;
  group: FormGroup;

  ngOnInit() {
   this.FormControlName = this.config.name;
  }

}
